var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronBottomIc(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    alt: "Abrir/Cerrar",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Abrir/Cerrar") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u2705-OV-CECEU---Desktop-CAMBIOS-ENE21",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Main---Ayuda",
    transform: "translate(-119.000000, -441.000000)",
    fill: "#087021"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(119.000000, 441.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.29289322,9.29289322 C7.65337718,8.93240926 8.22060824,8.90467972 8.61289944,9.20970461 L8.70710678,9.29289322 L12,12.585 L15.2928932,9.29289322 C15.6533772,8.93240926 16.2206082,8.90467972 16.6128994,9.20970461 L16.7071068,9.29289322 C17.0675907,9.65337718 17.0953203,10.2206082 16.7902954,10.6128994 L16.7071068,10.7071068 L12.7071068,14.7071068 C12.3466228,15.0675907 11.7793918,15.0953203 11.3871006,14.7902954 L11.2928932,14.7071068 L7.29289322,10.7071068 C6.90236893,10.3165825 6.90236893,9.68341751 7.29289322,9.29289322 Z",
    id: "\\uD83C\\uDF08Icon"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronBottomIc);
export default __webpack_public_path__ + "static/media/chevron_bottom_ic.5a66aeb9.svg";
export { ForwardRef as ReactComponent };